import { useQuery } from '@tanstack/react-query';
import {
  getAllUsersByProjectId,
  getLegalCaseOptions
} from '../../services/api/implementation/impl';

const NO_OPTIONS = {
  caseStatuses: [],
  caseTypes: [],
  riskLevels: [],
  actionParties: [],
  followUpModes: [],
  followUpStatuses: [],
  documentStatuses: [],
  pendingDocumentStatuses: []
};

/**
 * Court-case dropdown values from GET /task/legal-options — the backend owns
 * the lists. Forms wait for `loaded` before mounting their selects: an
 * uncontrolled select that mounts before its options falls back to the first
 * option instead of the form's default.
 */
export function useLegalCaseOptions({ enabled = true } = {}) {
  const { data } = useQuery({
    queryKey: ['legalCaseOptions'],
    queryFn: getLegalCaseOptions,
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false
  });
  const options = data?.data;
  return { ...NO_OPTIONS, ...(options || {}), loaded: !!options };
}

/**
 * People on the project, for "pending with" and follow-up owners. The API
 * checks each one is an internal user on the project. Shares its cache with
 * the owner picker (ownerOptions.js).
 */
export function useProjectUserOptions(projectId) {
  const { data, isSuccess } = useQuery({
    queryKey: ['projectUsers', projectId],
    queryFn: () => getAllUsersByProjectId(projectId, 1, 500),
    enabled: !!projectId
  });
  const options = (data?.data || [])
    .filter((user) => user?.id)
    .map((user) => ({ label: user.name || user.userName || `User #${user.id}`, value: user.id }));
  return { options, loaded: isSuccess };
}
